import React, { useEffect, useState } from "react";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg"; // Assuming error icon
import { ReactComponent as CloseIconBlackUniversal } from "../../assets/images/icons/CloseIconUniversalBlack.svg";
import useRequireAuth from "../../utils/useRequireAuth";
const FileAttachment = ({
  onChange,
  maxSize = 20,
  label = "Attachment",
  id,
  value,
  error = "",
  additionalText = "",
  height = "h-[120px]",
  width = "w-full",
  dashed = true,
  dropZoneClassName = "",
  wrapperClassName = "",

  style = {},
}) => {
  const [errorText, setErrorText] = useState(error);
  useEffect(() => {
    setErrorText(error);
  }, [error]);
  // Handle file change (selecting a file)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      processFile(file);
    }
  };

  // Handle file drop
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      processFile(file);
    }
  };

  // Process file (check size, update state)
  const processFile = (file) => {
    if (file.size <= maxSize * 1024 * 1024) {
      uploadFile(file);
    } else {
      setErrorText(`File exceeds the ${maxSize} MB limit.`);
    }
  };

  // Simulate file upload to backend
  const user = useRequireAuth();
  const uploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch("https://nodedata.unizooks.com/v1/accounts/vouchers/upload", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data?.status && data?.data?.file_path) {
        setErrorText("");
        const newFile = data?.data;
        if (value?.length) onChange([...value, newFile]);
        else onChange([newFile]);
      } else {
        setErrorText("Failed to upload the file.");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      setErrorText("Failed to upload the file.");
    }
  };

  const removeAttachment = (eachFile) => {
    const filteredData = value?.filter((data) => data?.blob_name !== eachFile?.blob_name);
    onChange(filteredData);
  };

  return (
    <div className={`flex flex-col mb-4 ${wrapperClassName}`} role="form">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1" aria-label={label}>
          <span className="font-semibold">{label}</span> Maximum Size {maxSize} MB
        </label>
      )}
      <div
        className={`flex items-center justify-center rounded-md border ${height} ${width} 
          ${dashed ? "border-dashed" : "border-solid"} 
          ${errorText ? "border-red-500" : "border-gray-300"} 
          ${dropZoneClassName}`}
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()} // Prevent the default behavior to allow dropping
        style={style}
      >
        <div className="flex flex-col items-center text-center">
          <span className="text-xs text-[#AFAFAF] font-normal">
            Drop a file here or click to select from the device
          </span>
          <div className="text-xs">Upload from this device</div>
          {additionalText}
          <input
            type="file"
            onChange={handleFileChange}
            className="hidden"
            id="fileInput"
            aria-describedby={errorText ? `${id}-helper` : undefined}
          />
          <label htmlFor="fileInput" className="cursor-pointer text-[#009CBF] text-xs font-normal mt-2">
            Choose a file
          </label>
        </div>
      </div>
      {errorText && value?.length < 1 && (
        <span
          id={`${id}-helper`}
          className="text-xs text-[#BF2315] mt-1 flex items-center gap-1"
          role="alert"
          aria-live="assertive"
        >
          <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
          {errorText}
        </span>
      )}

      {/* Display the file name and URL after upload */}
      {value && value?.length > 0 && (
        <div className="mt-4 text-sm border border-1-[#DFE2E5] rounded-md">
          <h3 className="font-medium border border-1-[#DFE2E5]  rounded-t-md p-2">Uploaded Files:</h3>
          <div className="p-2">
            {value.length > 0 &&
              value?.map((eachFile) => (
                <div key={eachFile?.blob_name} className="p-2 flex justify-between bg-[#D4EAEE] rounded-md mb-2">
                  <p>{eachFile?.document_name}</p>
                  <button onClick={() => removeAttachment(eachFile)}>
                    <CloseIconBlackUniversal className="w-[10px] h-[10px]" />
                  </button>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FileAttachment;
